import styled from 'styled-components';
import {mobileMedia, ellipsisLines, mediumMedia} from '../../../../../../../globalVariables/GlobalVariables';
import {getColor} from '../../../../../utils/themeUtils';
import {imageContainer, progress, progressContainer} from '../../../../../../subscriptions/components/planImage/PlanImage.css';
import {getFontSize, getFontWeight, getToken, getSpacing} from '@tickchak/react-share/app';
import {dFlexCenter, dFlexStart, justifyEnd, dFlexColumnCenter, alignStart} from '../../../../../../../globalVariables/GlobalFlex';
import {cell as headerCell} from '../subscriptionTableHeader/SubscriptionTableHeader.css';

export const row = styled.div`
    ${dFlexCenter}
    width: 100%;
    height: 58px;
    border: 1px solid var(--primitive-black-05);
    border-radius: ${getSpacing('spaceSm')};
    overflow: hidden;
    margin-top: ${getSpacing('spaceXs')};
    ${mobileMedia}{
        flex-direction: row;
        height: 97px;
        padding: 0;
        margin-top: ${getSpacing('spaceMd')};
        border-radius: 8px;
        width: 100%;
        &:first-child {
            margin-top: 0;
        }
    }
`;

export const cell = styled(headerCell)`
    min-width: 30px;
    padding: 0 ${getSpacing('spaceMd')};
    ${mobileMedia}{
        display: none;
    }
`;

export const mobileLabel = styled.span`
    display: none;
    color: var(--primitive-black-05);
    ${mobileMedia}{
        display: block;
    }
`;

export const nameSection = styled.div`
    ${dFlexStart}
    flex: 1;
    min-width: 200px;
    height: 100%;
    gap: ${getSpacing('spaceXs')};
    ${mobileMedia}{
        flex: 1;
        min-width: 0;
        height: 100%;
        ${justifyEnd}
    }
    ${mediumMedia}{
        min-width: 160px;
    }
    ${progressContainer}{
        bottom: 12px;
        ${mediumMedia}{
            height: 30px;
            width: 30px;
            bottom: 14px;
            inset-inline-end: -10px;
            ${progress}{
                height: 28px;
                width: 28px;
            }
        }
        ${mobileMedia}{
            bottom: 31px;
            height: 35px;
            width: 35px;
            inset-inline-end: -15px;
            ${progress}{
                height: 30px;
                width: 30px;
            }
        }
    }
    ${imageContainer}{
        width: 60px;
        height: 60px;
        ${mobileMedia}{
            width: 118px;
            height: 97px;
        }
    }
`;

export const infoWrapper = styled.div`
    ${dFlexColumnCenter}
    ${alignStart}
    flex: 1;
    gap: ${getSpacing('spaceXs')};
    padding: ${getSpacing('spaceSm')} ${getSpacing('spaceMd')} ${getSpacing('spaceSm')} 0;
    width: calc(100% - 64px);
    ${mediumMedia}{
        padding: ${getSpacing('spaceSm')} ${getSpacing('spaceXs')} ${getSpacing('spaceSm')} 0;
    }
    ${mobileMedia}{
        align-items: flex-start;
        justify-content: center;
        padding: ${getSpacing('spaceSm')} ${getSpacing('spaceMd')} ${getSpacing('spaceSm')} 0;
        height: 100%;
        min-width: 0;
        width: calc(100% - 118px);
        gap: ${getSpacing('spaceSm')};
    }
    
`;

export const statusBadge = styled.div<{$bgColor?: string}>`
    ${dFlexCenter}
    padding: ${getSpacing('spaceXxs')} ${getSpacing('spaceXs')};
    border-radius: 5px;
    background: ${p => p.$bgColor || 'var(--pink-200)'};
    font-size: ${getFontSize('caption')};
    line-height: 1.1;
    color: ${getToken('color.text.default')};
`;

export const seriesName = styled.div`
    font-size: ${getFontSize('body')};
    font-weight: ${getFontWeight('bold')};
    color: ${p => getColor(p.theme.isDarkMode)};
    text-align: start;
    ${ellipsisLines(1)}
    line-height: 1.2;
    width: 100%;
    ${mobileMedia}{
        ${ellipsisLines(2)}
    }
`;

export const moreInfoButton = styled.div`
    display: none;
    ${mobileMedia}{
        display: block;
        padding: 0 ${getSpacing('spaceLg')};
    }
`;
